/**
 * Skeleton loaders. Pure HTML strings — drop wherever you'd render real
 * content while a request is in flight, then replace the innerHTML once
 * the data arrives. Layout-stable (same dimensions as the real items)
 * so the UI doesn't jump.
 */

/** A list of layer-row-shaped placeholders, for My Layers / Catalog. */
export function listSkeleton(rows = 3) {
  return Array.from({ length: rows }, () => `
    <div class="skel-list-row">
      <div class="skel skel-toggle"></div>
      <div class="skel skel-dot"></div>
      <div class="skel-text-stack">
        <div class="skel skel-text-line long"></div>
        <div class="skel skel-text-line short"></div>
      </div>
    </div>
  `).join('');
}

/** Card-shaped placeholders, for the Stories grid. */
export function cardSkeleton(rows = 3) {
  return Array.from({ length: rows }, () => `
    <div class="skel-card">
      <div class="skel skel-text-line" style="height:18px;width:60%"></div>
      <div class="skel skel-text-line"></div>
      <div class="skel skel-text-line short"></div>
    </div>
  `).join('');
}
